import { render, staticRenderFns } from "./store-support.vue?vue&type=template&id=2f1a57b7&"
import script from "./store-support.vue?vue&type=script&lang=js&"
export * from "./store-support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports